module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/thermometer-mercury-cold-39a9e7fff8d72b9b5d1567fdeffc2ce8.svg";